import { lazy } from 'react';
import useLanguageRedirect from '../../Core/Hooks/HookUrlRedirect/useLanguageRedirect';
const InterestAreaScreen = lazy(() =>
  import('../../Components/Pages/InteresAreaScreen/InterestAreaScreen')
);

const TrainingsScreen = lazy(() =>
  import('../../Components/Pages/TrainingsScreen/TrainingsScreen')
);

const CourseInfoScreen = lazy(() =>
  import('../../Components/Pages/CourseInfoScreen/CourseInfoScreen')
);

const BrochureViewerPage = lazy(() => import('../../Components/Pages/BrochureViewerPage/BrochureViewerPage'));

export const RoutesUniversity = [
  {
    path: '/trainings',
    exact: true,
    component: useLanguageRedirect
  },
  {
    path: '/:language/trainings',
    exact: true,
    component: TrainingsScreen,
    showWhatsApp: true
  },
  {
    path: '/interest-area',
    exact: true,
    component: useLanguageRedirect
  },
  {
    path: '/:language/interest-area',
    exact: true,
    component: InterestAreaScreen,
    showWhatsApp: true

  },
  {
    path: '/course-info',
    exact: true,
    component: useLanguageRedirect
  },
  {
    path: '/:language/course-info',
    exact: true,
    component: CourseInfoScreen,
    showWhatsApp: true
  },
  {
    path: '/brochure-viewer',
    exact: true,
    component: useLanguageRedirect
  },
  {
    path: '/:language/brochure-viewer',
    exact: true,
    component: BrochureViewerPage
  }
];
